export interface MultiSelectOption<valueType = object | string | number | boolean | null> {
    label: string;
    value: valueType;
}
